import React from 'react';
import PropTypes from 'prop-types';

import AudioPlayer from './audio-player';

const AudioWrapper = ({ file }) => {
  const metadata = {
    song: file.name,
  };

  return (
    <div className="preview__item preview__item--audio">
      <div className="preview__audio">
        <div className="preview__audio-player">
          <AudioPlayer file={file} metadata={metadata} />
        </div>
      </div>
    </div>
  );
};

AudioWrapper.propTypes = {
  file: PropTypes.object,
  className: PropTypes.string,
};

export default AudioWrapper;
